import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';

const CandidateListItem = ({ candidate, onSelect }) => {
  // const preview = candidate.preview;
  if (candidate.exists) {
    return (
      <ListGroup.Item variant='light'>
        <div className='d-flex flex-column gap-1'>
          <div className='d-flex align-items-center gap-2 flex-wrap'>
            <span>{candidate.word}</span>
            <Badge pill bg='success'>
              Added
            </Badge>
          </div>
          {/* {preview && <small className='text-muted'>{preview}</small>} */}
        </div>
      </ListGroup.Item>
    );
  }
  return (
    <ListGroup.Item action variant='light' onClick={() => onSelect(candidate)}>
      <div className='d-flex flex-column gap-1'>
        <span>{candidate.word}</span>
        {/* {preview && <small className='text-muted'>{preview}</small>} */}
      </div>
    </ListGroup.Item>
  );
};

export default CandidateListItem;
